<template>
  <div>
  <div class="host-revenue" >
    <div class="host-revenue__header">
      <div class="host-revenue__header__title">
        <h1 class="medium-title">Balance</h1>
      </div>
    </div>
    <div class="host-revenue__content" v-if="!isUnauthorized && !isLoading">
      <list-item :items="sortedData" :loading="isLoading">
        <adx-loading v-if="isLoading" :loading="isLoading" slot="loading" />
      </list-item>
      <adx-pagination
        v-if="!isLoading && !isEmpty"
        @change-page="changePage"
        :max-page="maxPage"
        :selected-page="currentPage"
       />
      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !isLoading" :subtitle="` `"/>
      </div>
    </div>
    <div class="isUnauthorized">
        <adx-empty-selection v-if="isUnauthorized" :subtitle="` `"/>
    </div>
  </div>
  </div>
</template>

<script>
import ListItem from '@/views/Dashboard/CampaignHostRevenue/ListItems'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import EmptySelection from '@/components/NotFound/Selection'

import api from '@/api'
import moment from "moment";

import { mapGetters } from 'vuex'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-dashboard-host-revenue',
  components: {
    ListItem,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-empty-selection': EmptySelection,
  },
  data() {
    return {
      title: 'Balance',
      balance: 0,
      msgEmpty: 'You have no transactions.',
      isEmpty: false,
      isLoading: true,
      isUnauthorized: false,
      progressBar1: 0,
      currentPage: 1,
      maxPage: 1,
      nextPage: null,
      currentPage: 1,
      transactions: [],
    }
  },
  computed: {
    sortedData() {
      return this.transactions;
    },
  },
  watch: {
    currentPage() {
      this.getData(this.prepareQuery());
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    try {
      (async () => {
        const { data } = await api.get(apiV2.campaignHostRevenueBalance, { needToken: true })
        if(data.balance != null){
          this.$data.balance = data.balance
        }
      })();
    } catch (err) {
      
    }
    this.getData(this.prepareQuery());
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getData(data_query) {
      try {
        (async () => {
          this.$data.isLoading = true;
          this.isEmpty = false
          this.isUnauthorized = false
          const { data } = await api.get(apiV2.campaignHostRevenueReport, { params: data_query, needToken: true })
          console.log('data', data)
          if (!data.results) {
            this.isUnauthorized = true
          } else {
            let transactions = data.results
            if (transactions.length > 0) {
              this.transactions = transactions
              this.maxPage = data.max_page
            } else {
              this.isEmpty = true
            }
          }
          this.$data.isLoading = false;
          //
          
        })();
      } catch (err) {
        
      }
    },
    prepareQuery(){
      let query = {
        page: this.$data.currentPage
      }
      return query;
    },
    changePage (selected) {
      this.$data.currentPage = selected;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      history.pushState(null, null, '?page=' + selected);
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
